var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "app-footer no-print" }, [
    _c("div", { staticClass: "footer-wrap" }, [
      _c(
        "div",
        { staticClass: "footer-logo" },
        [
          _c(
            "a",
            {
              attrs: {
                href: "https://asokoinsight.com",
                "aria-label": "Asoko Insight Logo",
              },
            },
            [_c("asoko-logo-transparent")],
            1
          ),
          _vm._v(" "),
          _c("app-copyright"),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer-content" }, [
        _c("div", { staticClass: "footer-blocks" }, [
          _c(
            "div",
            { staticClass: "footer-block first-block" },
            [
              _c("h6", [_vm._v("About Us")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            Asoko Insight is Africa's leading corporate data and engagement platform, providing global investors, multinationals and development institutions the most effective route to discover, shortlist and engage their target universe of African companies.\n          "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "link-details", attrs: { to: "/about/team" } },
                [_vm._v("\n            Read More\n          ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "inner-block" },
                [
                  _c("h6", [_vm._v("Press")]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-details",
                      attrs: { to: "/insights/developments" },
                    },
                    [_vm._v("\n              Corporate news\n            ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-block narrow-block" }, [
            _c("h6", [_vm._v("Our Offices")]),
            _vm._v(" "),
            _c("p", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://goo.gl/maps/A4k7JqNW2ETWo7449",
                    target: "_blank",
                    rel: "noopener",
                  },
                  on: { click: _vm.trackOurOfficesClick },
                },
                [_vm._v("London, UK")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer-block" }, [
            _c("h6", [_vm._v("Contacts")]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-item" }, [
              _c("p", [_vm._v("General Enquiries")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: { href: "mailto:info@asokoinsight.com" },
                    on: { click: _vm.trackContactsClick },
                  },
                  [_vm._v("info@asokoinsight.com")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-item" }, [
              _c("p", [_vm._v("News Enquiries")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: { href: "mailto:editorial@asokoinsight.com" },
                    on: { click: _vm.trackContactsClick },
                  },
                  [_vm._v("editorial@asokoinsight.com")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-item" }, [
              _c("p", [_vm._v("Custom Sales Enquiries")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: { href: "mailto:sales@asokoinsight.com" },
                    on: { click: _vm.trackContactsClick },
                  },
                  [_vm._v("sales@asokoinsight.com")]
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "footer-blocks" }, [
          _c(
            "div",
            { staticClass: "footer-block first-block" },
            [
              _c("h6", [_vm._v("Careers")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            Asoko is growing fast and has exciting apportunities in multiple\n            locations.\n          "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "link-details",
                  attrs: { to: "/about/careers" },
                },
                [_vm._v("See Current Openings")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-block split-block" }, [
            _c(
              "div",
              { staticClass: "split-child social-block narrow-block" },
              [
                _c("h6", [_vm._v("Follow Us")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://www.facebook.com/asokoinsight",
                      "aria-label": "Asoko Insight Facebook",
                      rel: "noopener",
                    },
                  },
                  [_c("facebook-icon")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://twitter.com/AsokoInsight",
                      "aria-label": "Asoko Insight Twitter",
                      rel: "noopener",
                    },
                  },
                  [_c("twitter-icon")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://www.linkedin.com/company/asoko-insight",
                      "aria-label": "Asoko Insight Linkedin",
                      rel: "noopener",
                    },
                  },
                  [_c("linkedin-icon")],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("img", {
      staticStyle: { display: "none" },
      attrs: {
        height: "1",
        width: "1",
        alt: "",
        src: "https://px.ads.linkedin.com/collect/?pid=2807145&fmt=gif",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }